import { api_path } from "../../../../environment";

export const apiPaths = {
  baseUrl: api_path,
};

export const setHeaders = async (headers: Headers) => {
  const token = localStorage.getItem("acessToken");
  if (token) {
    headers.set("authorization", `Bearer ${token}`);
  }
  headers.set("content-type", "application/json");
  return headers;
};
